var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    viewBox: "0 96 960 960",
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M477.028 810Q493 810 504 798.972q11-11.028 11-27T503.972 745q-11.028-11-27-11T450 745.028q-11 11.028-11 27T450.028 799q11.028 11 27 11ZM444 662h57q0-31 10-50.5t34.721-44.221Q579 534 592 508.5t13-53.5q0-53-34-84t-91.523-31q-51.866 0-88.171 24.5Q355 389 338 432l53 22q14-28 36.2-42.5Q449.4 397 479 397q32 0 50.5 16t18.5 44.098Q548 477 537 495.5T500 539q-37 35-46.5 60t-9.5 63ZM180 936q-24 0-42-18t-18-42V276q0-24 18-42t42-18h600q24 0 42 18t18 42v600q0 24-18 42t-42 18H180Zm0-60h600V276H180v600Zm0-600v600-600Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaq);
export default __webpack_public_path__ + "static/media/faq.a129d11a97d1dccd8d2df78e0f0d3afe.svg";
export { ForwardRef as ReactComponent };